import BaseUpdateRequest from "@/models/Shared/BaseUpdateRequest";

export default class UpdateJobWorkerOfferRequest extends BaseUpdateRequest {
    jobWorkerOfferId: string;
    annualSalary = 0;
    expiryDate: Date;
    description = '';
}